import { render, staticRenderFns } from "./DiscountCalculationList.vue?vue&type=template&id=ed6d2558&"
import script from "./DiscountCalculationList.vue?vue&type=script&lang=js&"
export * from "./DiscountCalculationList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports